import EnvConfig from "@/const/configs/env.config.js";

export const CommonConstant = {
  AESKey: "3t",
  COOKIE_NAME: EnvConfig.ENVIRONMENT + "_storage",
  COOKIE_DOMAIN: ".123-ai.cn"
};
